<template>
  <p :class="getClasses">{{ text }}</p>
</template>
<script>
export default {
  props: {
    text: { type: String, default: "" },
    size: { type: String, default: "quinary" },
    weight: { type: String, default: "" },
    color: { type: String, default: "blue__darker" },
    type: { type: String, default: "title" }
  },
  computed: {
    getClasses() {
      let classesString = "";
      if (this.$config.isMobile) {
        classesString += "is-mobile ";
      }
      if (this.size) {
        classesString += `size__${this.size} `;
      }
      if (this.weight) {
        classesString += `weight__${this.weight} `;
      }
      if (this.color) {
        classesString += `color__${this.color} `;
      }
      if (this.type) {
        classesString += `type__${this.type} `;
      }
      if(this.type == "title") {
        classesString += `title`;
      }
      return classesString;
    },
  },
};
</script>
<style lang="scss" scoped>
.type__title {
  font-weight: 500;
  color: var(--blue__darker);
}

.type__normal {
  padding-top: 5px;
}

//refctor
.size__x-small {
  font-size: 13px;
}
.size__small {
  font-size: 14px;
}

.size__primary {
  font-size: var(--font-size__primary);
}
.size__secondary {
  font-size: var(--font-size__secondary);
}
.size__tertiary {
  font-size: var(--font-size__tertiary);
}
.size__quaternary {
  font-size: var(--font-size__quaternary);
}
.size__quinary {
  font-size: var(--font-size__quinary);
}
.size__esary {
  font-size: var(--font-size__esary);
}
.weight__normal {
  font-weight: var(--font-weight__normal);
}
.weight__bold {
  font-weight: var(--font-weight__bold);
}
.color__black {
  color: var(--black);
}
.color__blue__dark {
  color: var(--blue__dark);
}
.color__blue__darker {
  color: var(--blue__darker);
}
.color__gray__darker {
  color: var(--gray__darker);
}
.color__gray__darkest {
  color: var(--gray__darkest);
}
</style>
